module.exports = __webpack_public_path__ + "img/bg.ae641bdb.jpg";